import { NO_ELEMENT, rm } from 'utils';
import { WrappedFieldInputProps } from 'redux-form';
import styles from './delivery.scss';
import { RadioButton } from 'components/Shared/Form';
import { DeliveryOptionItem } from 'models/DeliveryOptionItem';
import { useToggle } from 'hooks';
import { ServicePointDeliveryOptions } from './servicePointDeliveryOptions';
import logoAirmee from 'assets/img/checkout/logo_airmee.svg';

interface Props {
  input: WrappedFieldInputProps;
  deliveryOptions: DeliveryOptionItem[];
  selectedDeliveryId: string;
  identifier: string;
  onServicePointSelect?: (
    deliveryId: string,
    deliveryOption: DeliveryOptionItem,
    syncServicePoints: boolean
  ) => void;
  hasRelatedDeliveries: boolean;
  displayOpeningHours?: boolean;
}

export const DeliveryOption = ({
  input,
  deliveryOptions,
  selectedDeliveryId,
  identifier,
  onServicePointSelect,
  hasRelatedDeliveries,
  displayOpeningHours
}: Props) => {
  // If deliveryOptions.length > 1 then it´s ServicePoints
  const firstDeliveryOption = deliveryOptions[0];
  const displayName =
    deliveryOptions.length > 1 ? rm('checkout_service_point') : firstDeliveryOption?.name;
  const price = firstDeliveryOption?.lineAmount > 0 ? firstDeliveryOption?.lineAmountString : '';
  const selectedDisplayName =
    deliveryOptions.length > 1
      ? deliveryOptions.find(o => o.deliveryOptionIdentifier === selectedDeliveryId)
          ?.servicePointInformation?.displayName ??
        firstDeliveryOption?.servicePointInformation?.displayName
      : '';
  const isActive = deliveryOptions.some(o => o.deliveryOptionIdentifier === selectedDeliveryId);
  const [simpleMode, toggleSimpleMode] = useToggle(true);

  const servicePointInformation =
    deliveryOptions.length > 1
      ? deliveryOptions.find(o => o.deliveryOptionIdentifier === selectedDeliveryId)
          ?.servicePointInformation ?? firstDeliveryOption?.servicePointInformation
      : undefined;

  if (!simpleMode && !isActive) {
    toggleSimpleMode();
  }

  const promoted = deliveryOptions.find(d => d.forwarderIdentifier === 'Airmee');

  return (
    <RadioButton
      size="small"
      {...input}
      checked={deliveryOptions.some(o => o.deliveryOptionIdentifier === selectedDeliveryId)}
      value={firstDeliveryOption?.deliveryOptionIdentifier ?? ''}
      className={styles.deliveryOptionRadioButtonWrapper}
      radioButtonClassName={styles.deliveryOptionRadioButton}
      label={
        <>
          <span className={styles.displayName}>
            <div>
              {selectedDisplayName ? selectedDisplayName : displayName}
              {displayOpeningHours ? (
                <p>
                  {rm('checkout_rental_depot_open')} {servicePointInformation?.openingHours}
                  {servicePointInformation?.communicationText && (
                    <>
                      <br />
                      {servicePointInformation.communicationText}
                    </>
                  )}
                </p>
              ) : (
                NO_ELEMENT
              )}
            </div>
            {promoted && (
              <img className={styles.logo} src={logoAirmee} alt={promoted.forwarderIdentifier} />
            )}
          </span>
          <span className={styles.price}>{price}</span>
          {selectedDisplayName && simpleMode && (
            <a className={styles.change} onClick={toggleSimpleMode}>
              {rm('checkout_change_delivery_drop_point')}
            </a>
          )}
          {!simpleMode && isActive && (
            <div className={styles.servicePointSelector}>
              <ServicePointDeliveryOptions
                onChange={onServicePointSelect}
                selectedServicePoint={deliveryOptions.find(
                  o => o.deliveryOptionIdentifier === selectedDeliveryId
                )}
                disabled={false}
                deliveryId={identifier}
                deliveryOptions={deliveryOptions}
                simpleMode={simpleMode}
                toggleSimpleMode={toggleSimpleMode}
                hasRelatedDeliveries={hasRelatedDeliveries}
              />
            </div>
          )}
        </>
      }
    />
  );
};
